export function getStageOptions(stages) {
  return [{ label: 'Any', value: '' }].concat(
    Object.values(stages).map(({ label, key }) => (
      {
        label,
        value: key,
      }
    ))
  );
}